import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import AppointmentController from "./controllers/appointment_controller"
import DelayController from "./controllers/delay_controller"
import ToastController from "./controllers/toast_controller"
import SearchController from "./controllers/search_controller"
import StripeCardController from "./controllers/stripe_card_controller"
import InstallPromptController from "./controllers/install_prompt_controller"
import ConfirmModalController from "./controllers/confirm_modal_controller"
import CountrySelectController from "./controllers/country_select_controller"
import RevealController from "./controllers/reveal_controller"
import PricingToggleController from "./controllers/pricing_toggle_controller"
import ScrollParallaxController from "./controllers/scroll_parallax_controller"
import DeviceClockController from "./controllers/device_clock_controller"
import WaitClockController from "./controllers/wait_clock_controller"

// Register service worker for PWA
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker").catch(() => {
      // Silent fail — service worker is progressive enhancement
    })
  })
}

const application = Application.start()
application.register("appointment", AppointmentController)
application.register("delay", DelayController)
application.register("toast", ToastController)
application.register("search", SearchController)
application.register("stripe-card", StripeCardController)
application.register("install-prompt", InstallPromptController)
application.register("confirm-modal", ConfirmModalController)
application.register("country-select", CountrySelectController)
application.register("reveal", RevealController)
application.register("pricing-toggle", PricingToggleController)
application.register("scroll-parallax", ScrollParallaxController)
application.register("device-clock", DeviceClockController)
application.register("wait-clock", WaitClockController)
